import { RightOutlined } from "@ant-design/icons";
import React from "react";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import "./style.scss";
import _ from "lodash";
import InView from "react-intersection-observer";
import {
  getImageOrVideoPath,
  handleChangeIntersection,
} from "../../shared/helpers";

const SectionCategoryInformationPair = (props: any) => {
  const { sectionItem, history } = props;

  const colors: ISectionCSS = {
    "--backgroundColor": sectionItem.background_color || "#fff",
  };

  const handleClick = (e: any, url: string = "/") => {
    e.preventDefault();
    history.push(url);
  };

  const showItems = (items: any) =>
    items.map((item: any, index: number) => {
      const colorsItem: ISectionCSS = {
        "--color": item.color || "#000",
        "--backgroundColor": item.background_color || "#000",
        "--colorTitle": item.color_title || "#000",
        "--colorContent": item.color_content || "#000",
      };

      return (
        <div
          key={index}
          style={colorsItem}
          className="kd-section-categories-item">
          <div className="kd-section-categories-item-sub-img">
            <InView
              triggerOnce
              onChange={(inView, entry) =>
                handleChangeIntersection(inView, entry, "img-animation")
              }>
              <img src={getImageOrVideoPath(item.sub_images)} alt="" />
            </InView>
          </div>
          <div className="kd-section-categories-item-body">
            <InView
              triggerOnce
              onChange={(inView, entry) =>
                handleChangeIntersection(inView, entry, "text-to-top-animation")
              }>
              <div className="kd-section-categories-item-body-title main-title">
                {item.title}
              </div>
            </InView>
            <InView
              triggerOnce
              onChange={(inView, entry) =>
                handleChangeIntersection(inView, entry, "text-to-top-animation")
              }>
              <div className="kd-section-categories-item-body-description main-content">
                {item.content}
              </div>
            </InView>
            <InView
              triggerOnce
              onChange={(inView, entry) =>
                handleChangeIntersection(inView, entry, "text-to-top-animation")
              }>
              <div className="kd-section-actions kd-section-categories-item-body-actions main-content">
                {item.url ? (
                  <a onClick={(e: any) => handleClick(e, item.url)}>
                    Chi tiết <RightOutlined style={{ fontSize: 10 }} />
                  </a>
                ) : null}
                <a
                  onClick={(e: any) => handleClick(e, item.url_products)}
                  style={{ marginRight: 0 }}>
                  Mua ngay <RightOutlined style={{ fontSize: 10 }} />
                </a>
              </div>
            </InView>
          </div>
          <div className="kd-section-categories-item-img">
            <img src={getImageOrVideoPath(item.images)} alt="" />
          </div>
        </div>
      );
    });

  return sectionItem ? (
    <div style={colors} className="kd-section-categories">
      {sectionItem.children && sectionItem.children.length
        ? showItems(_.sortBy(sectionItem.children, ["order"]))
        : null}
    </div>
  ) : null;
};

export default SectionCategoryInformationPair;
